if (!customElements.get('product-care-accordion')) {
  class ProductCareAccordion extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');

      if (!this.details || !this.summary) return;

      this.syncAriaExpanded();
      this.details.addEventListener('toggle', () => this.syncAriaExpanded());
    }

    syncAriaExpanded() {
      this.summary.setAttribute('aria-expanded', this.details.open ? 'true' : 'false');
    }
  }

  customElements.define('product-care-accordion', ProductCareAccordion);
}
